module.exports = __webpack_public_path__ + "img/IcnPause.60259c7f.png";